import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EmptiesPage } from '@/features/empties/pages/EmptiesPage'

const searchSchema = z.object({
  tab: z.enum(['groups', 'stock', 'movements', 'deposits']).catch('groups'),
})

export const Route = createFileRoute('/_app/empties/')({
  validateSearch: searchSchema,
  component: EmptiesPage,
})
